import React from "react";
import type { TFunction } from "i18next";
import { ResourceEnum } from "src/constants/constants.ts";
import type { Module } from "src/system/module.types.ts";
import type { VoucherSerieResource } from "@exonn/js-sdk";

export const module: Module<VoucherSerieResource> = {
  id: ResourceEnum.VoucherSerie,
  smallIcon: <span className={"icon-15-vouchers"} />,
  name: (t: TFunction) => t("moduleName.voucher-series"),
  bigIcon: <span className={"icon-20-vouchers"} />,
  tabs: {
    edit: {
      getTitle: (resource) => resource.title,
    },
  },
  formTabs: {
    general: {
      title: (t) => t("formTabs.general.title"),
    },
    vouchersAndGeneration: {
      title: (t) => t("formTabs.vouchers-and-generation.title"),
      routeObject: {
        lazy: () =>
          import(
            "src/admin/modules/voucher-serie/routes/edit/tabs/vouchers-and-generation/vouchers-and-generation.tsx"
          ),
      },
    },
  },
};
